import { Waves } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CtaBand({ title = 'Envie d’échanger sur votre projet ?', text = 'Je serai ravie d’échanger avec vous.', action = 'Me contacter' }) {
  return (
    <section className="cta-band">
      <div className="cta-waves left" />
      <div className="cta-copy"><h2>{title}</h2><p>{text}</p></div>
      <Link className="button button-light" to="/contact">{action} <Waves size={18} /></Link>
      <div className="cta-waves right" />
    </section>
  );
}
